// config.js

export const SALENG_GREEN_API_PROD = "https://api.saleng.tjl.co.th";
export const SALENG_SHOP_API_PROD = "https://api-test.akka.getkaset.com";
export const LOCAL_URL = "http://localhost:3001";